import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Box,
  TextField,
  Typography,
  styled,
} from "@mui/material";

export const StyledBox = styled(Box)({
  // width: "50%",
  height: 400,
  backgroundColor: "#151A27",
  borderRadius: "28px",
  padding: "16px",
  border: "0.2px solid grey",
});

export const GradientTypography = styled(Typography)({
  background: "linear-gradient(to right, #00245E, #2843FF, #00BD61, #00BD61)",
  backgroundClip: "text",
  textFillColor: "transparent",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
});

export const GradientButton = styled(LoadingButton)({
  background:
    "linear-gradient(90deg, rgba(0,36,94,1) 0%, rgba(40,67,255,1) 47%, rgba(0,189,97,1) 70%)",
  marginTop: "16px",
  borderRadius: "28px",
});

export const DarkTextField = styled(TextField)({
  "& .MuiFilledInput-input": {
    backgroundColor: "rgba(255, 255, 255, 1)",
    borderRadius: "28px",
    paddingLeft: "20px",
  },

  '& .MuiFormHelperText-root': {
    minHeight: '1em', // Adjust this value based on your design needs
  },

  "& .MuiFilledInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:after": {
    borderBottom: "none",
  },

  "& .MuiFilledInput-root": {
    borderRadius: "28px",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    "&.Mui-focused": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    "&:before": {
      borderRadius: "28px",
    },
    "&:after": {
      borderRadius: "28px",
    },
  },
  "& .MuiInputLabel-root": {
    paddingLeft: "10px",
  },
});

export const DarkSelect = styled(Autocomplete)({
  "& .MuiAutocomplete-listbox": {
    backgroundColor: "#fff",
    color: "#000",
  },

  "& .MuiFilledInput-input": {
    backgroundColor: "rgba(255, 255, 255, 1)",
    borderRadius: "28px",
    paddingLeft: "10px !important",
  },

  "& .MuiFilledInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:after": {
    borderBottom: "none",
  },

  "& .MuiFilledInput-root": {
    borderRadius: "28px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    '& .MuiFormHelperText-root': {
      minHeight: '1em', 
    },
    "&.Mui-focused": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    "&:before": {
      borderRadius: "28px",
    },
    "&:after": {
      borderRadius: "28px",
    },
  },
  "& .MuiInputLabel-root": {
    paddingLeft: "10px",
  },
});
